// Generated by @hypernym/nuxt-gsap
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export const useGsap = gsap;
export const useScrollTrigger = ScrollTrigger;